module.exports = __webpack_public_path__ + "img/san-jose-restaurant-2.959cba63.jpg";